var map = {
	"./main/pages/calendar/calendar.module": "./src/app/main/pages/calendar/calendar.module.ts",
	"./main/pages/car-information/car-informations.module": "./src/app/main/pages/car-information/car-informations.module.ts",
	"./main/pages/coWorker/coWorker.module": "./src/app/main/pages/coWorker/coWorker.module.ts",
	"./main/pages/companyInfo/companyInfo.module": "./src/app/main/pages/companyInfo/companyInfo.module.ts",
	"./main/pages/customer/customer.module": "./src/app/main/pages/customer/customer.module.ts",
	"./main/pages/dashboard/dashboard.module": "./src/app/main/pages/dashboard/dashboard.module.ts",
	"./main/pages/document/document.module": "./src/app/main/pages/document/document.module.ts",
	"./main/pages/inquiry/inquiry.module": "./src/app/main/pages/inquiry/inquiry.module.ts",
	"./main/pages/material/material.module": "./src/app/main/pages/material/material.module.ts",
	"./main/pages/message/message.module": "./src/app/main/pages/message/message.module.ts",
	"./main/pages/nanolink/nanolink.module": "./src/app/main/pages/nanolink/nanolink.module.ts",
	"./main/pages/payroll/payroll.module": "./src/app/main/pages/payroll/payroll.module.ts",
	"./main/pages/project-offer/project-offer.module": "./src/app/main/pages/project-offer/project-offer.module.ts",
	"./main/pages/project/project.module": "./src/app/main/pages/project/project.module.ts",
	"./main/pages/quality-test/quality-test.module": "./src/app/main/pages/quality-test/quality-test.module.ts",
	"./main/pages/quickinvoice/quickinvoice.module": "./src/app/main/pages/quickinvoice/quickinvoice.module.ts",
	"./main/pages/report/report.module": "./src/app/main/pages/report/report.module.ts",
	"./main/pages/settings/settings.module": "./src/app/main/pages/settings/settings.module.ts",
	"./main/pages/statistic/statistic.module": "./src/app/main/pages/statistic/statistic.module.ts",
	"./main/pages/suppliers/suppliers.module": "./src/app/main/pages/suppliers/suppliers.module.ts",
	"./main/pages/terms-of-employment/terms-of-employment.module": "./src/app/main/pages/terms-of-employment/terms-of-employment.module.ts",
	"./main/pages/tools-and-ladders/tools-and-ladders.module": "./src/app/main/pages/tools-and-ladders/tools-and-ladders.module.ts",
	"./main/pages/workHour/workHour.module": "./src/app/main/pages/workHour/workHour.module.ts"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;